import { Button, Grid, Stack } from '@vapor/material'
import { useTranslation } from 'react-i18next'
import { ToolbarButton } from './form-layout.types'
import { CircularProgress, SxProps } from '@mui/material'
import React from 'react'

export type FormLayoutDefaultToolbarProps = {
  saveButton?: ToolbarButton
  cancelButton?: ToolbarButton
  deleteButton?: ToolbarButton
  customButtons?: ToolbarButton[]
  infoBox?: React.ReactNode
  customStyle?: SxProps
  leftItem?: JSX.Element
}

/**
 * Toolbar standard con bottoni Salva, Elimina, Annulla e lista di eventuali azioni aggiuntive.
 * @param props
 * @returns
 */
export const FormLayoutDefaultToolbar = (props: FormLayoutDefaultToolbarProps) => {
  const { t } = useTranslation()
  return (
    <Stack direction="row" justifyContent={props.leftItem ? 'space-between' : 'flex-end'} alignItems="center" width="100%" sx={props.customStyle} maxHeight="72px">
      {props.leftItem}
      <Grid container columnSpacing={2} direction={'row-reverse'}>
        {props.saveButton?.clickHandler && (
          <Grid item>
            <Button
              data-test
              id="btn-main"
              variant={props.saveButton.variant ?? 'contained'}
              onClick={props.saveButton.clickHandler}
              disabled={props.saveButton.disabled}
              startIcon={props.saveButton.startIcon}
              endIcon={props.saveButton.loading ? <CircularProgress size={20} style={{ color: 'white' }} /> : undefined}
              color={props.saveButton.color}
            >
              {props.saveButton.text ?? t('commons.save')}
            </Button>
            {props.saveButton.clickConfirmDialog}
          </Grid>
        )}
        {props.cancelButton?.clickHandler && (
          <Grid item>
            <Button
              data-test
              id="btn-secondary"
              variant={props.cancelButton?.variant ?? 'outlined'}
              onClick={props.cancelButton.clickHandler}
              disabled={props.cancelButton.disabled}
              startIcon={props.cancelButton.startIcon}
              color={props.cancelButton.color}
            >
              {props.cancelButton.text ?? t('commons.cancel')}
            </Button>
            {props.cancelButton.clickConfirmDialog}
          </Grid>
        )}
        {props.deleteButton?.clickHandler && (
          <Grid item>
            <Button
              data-test
              id="btn-secondary"
              variant={props.deleteButton.variant ?? 'text'}
              color="error"
              onClick={props.deleteButton.clickHandler}
              disabled={props.deleteButton.disabled}
              startIcon={props.deleteButton.startIcon}
            >
              {props.deleteButton.text ?? t('commons.delete')}
            </Button>
            {props.deleteButton.clickConfirmDialog}
          </Grid>
        )}
        {props.customButtons &&
          props.customButtons.map((b, index) => (
            <React.Fragment key={index}>
              <Grid item>
                <Button data-test id="btn-secondary" variant={b.variant ?? 'outlined'} onClick={b.clickHandler} disabled={b.disabled} startIcon={b.startIcon}>
                  {b.text ?? ''}
                </Button>
              </Grid>
              {b.clickConfirmDialog}
            </React.Fragment>
          ))}
        {props.infoBox && (
          <Grid item flexGrow={1} /* flexGrow so it takes all the available space */>
            {props.infoBox}
          </Grid>
        )}
      </Grid>
    </Stack>
  )
}
